import { __assign, __generator, __rest } from "tslib";
import { all, takeEvery, select, put, call, takeLatest, delay, } from 'redux-saga/effects';
import { moveNext, movePrev, setCurrentItem, setCurrentStreamAndItem, exitDuperbrowse, openDuperbrowse, shutdownDuperbrowse, exitDuperbrowseDone, loadDuperbrowseItem, loadDuperbrowse, openDuperbrowseWithEntities, unloadDuperbrowseItem, exitDuperbrowseResorationTimeout, } from './actionCreators';
import { getNextItem, getPrevItem, getIsValidStreamItem, getCurrentStreamId, getCurrentItem, getRootLocation, getCurrentStreamSchema, getIsAnyStreamActive, getIsDuperbrowseActive, getIsHistoryManagementEnabled, getNeedsToLoadMore, } from './selectors';
import { getStreamItemId, getStreamItemUrl, isDeviationStream, isDuperbrowseLocation, getNormalizedStreamItemId, getBiEventData, } from './helpers';
import { duperbrowseHistoryChanged, historyChanged, } from '../../redux/routing/actions';
import history from '../../redux/routing/history';
import { createLocation } from 'history';
import { isSimpleStream, } from './types';
import { handleLoading } from './loader';
import ddt from '@wix/da-ddt';
import { normalize } from 'normalizr';
import { deviationListSchema } from '../../redux/normalizr/schemas/deviation';
import { logBiEvent } from '../../biLogger/redux/saga';
import { getPageBiContext } from '../../biLogger/redux/selectors';
import { actions as streamActions } from '../../Stream';
import { scrollTo } from '../../utils/browser';
var logger = ddt.createLogger('duperbrowse');
function getNonDuperHistoryState() {
    var _a = history.location.state || {}, duperbrowseState = _a.duperbrowseState, duperbrowseRoot = _a.duperbrowseRoot, restState = __rest(_a, ["duperbrowseState", "duperbrowseRoot"]);
    return restState;
}
function updateHistoryWith(item) {
    var isEnabled, streamId, url, itemId, state, newLocation;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getIsHistoryManagementEnabled)];
            case 1:
                isEnabled = _a.sent();
                if (!isEnabled) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getCurrentStreamId)];
            case 2:
                streamId = _a.sent();
                url = getStreamItemUrl(item);
                itemId = getStreamItemId(item);
                if (!streamId || !url || !itemId) {
                    return [2 /*return*/];
                }
                state = {
                    duperbrowseState: {
                        streamId: streamId,
                        itemId: itemId,
                    },
                };
                newLocation = createLocation(url, state, undefined, history.location);
                history.push(newLocation);
                return [2 /*return*/];
        }
    });
}
function moveToItem(item, direction) {
    var biContext, currentItem, schema, itemId, needsToLoadMore, streamId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                // TODO: deal with loading state
                if (!item) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getPageBiContext)];
            case 1:
                biContext = _a.sent();
                return [4 /*yield*/, select(getCurrentItem)];
            case 2:
                currentItem = _a.sent();
                return [4 /*yield*/, select(getCurrentStreamSchema)];
            case 3:
                schema = _a.sent();
                itemId = getNormalizedStreamItemId(item);
                logger.log("Moving to ".concat(direction, " item"), item);
                if (!currentItem) return [3 /*break*/, 5];
                return [4 /*yield*/, call(logBiEvent, __assign(__assign({}, biContext), getBiEventData(currentItem, direction, item)))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [4 /*yield*/, put(unloadDuperbrowseItem(currentItem))];
            case 6:
                _a.sent();
                return [4 /*yield*/, call(updateHistoryWith, item)];
            case 7:
                _a.sent();
                return [4 /*yield*/, all([
                        put(setCurrentItem(itemId)),
                        put(loadDuperbrowseItem(itemId, schema, direction)),
                    ])];
            case 8:
                _a.sent();
                return [4 /*yield*/, select(getNeedsToLoadMore, direction)];
            case 9:
                needsToLoadMore = _a.sent();
                if (!needsToLoadMore) return [3 /*break*/, 12];
                return [4 /*yield*/, select(getCurrentStreamId)];
            case 10:
                streamId = _a.sent();
                return [4 /*yield*/, put(streamActions.fetch(streamId, direction))];
            case 11:
                _a.sent();
                _a.label = 12;
            case 12: return [2 /*return*/];
        }
    });
}
export function handleMoveNext() {
    var nextItem;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getNextItem)];
            case 1:
                nextItem = _a.sent();
                return [4 /*yield*/, call(moveToItem, nextItem, 'next')];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export function handleMovePrev() {
    var prevItem;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getPrevItem)];
            case 1:
                prevItem = _a.sent();
                return [4 /*yield*/, call(moveToItem, prevItem, 'prev')];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleHistoryChange(_a) {
    var isDuperActive, isDuperLocation, _b, streamId, itemId, isValid, currentItem;
    var _c = _a.payload, location = _c.location, action = _c.action;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                // we only need to handle popstates
                if (action !== 'POP') {
                    return [2 /*return*/];
                }
                // if there is no state, bail
                if (!location.state) {
                    window.location.reload();
                    return [2 /*return*/];
                }
                if (!(location.state.duperbrowseRoot === true)) return [3 /*break*/, 4];
                return [4 /*yield*/, select(getIsDuperbrowseActive)];
            case 1:
                isDuperActive = _d.sent();
                return [4 /*yield*/, put(shutdownDuperbrowse())];
            case 2:
                _d.sent();
                // clean up
                history.replace(__assign(__assign({}, history.location), { state: getNonDuperHistoryState() }));
                isDuperLocation = isDuperbrowseLocation(location, true);
                if (!isDuperActive && !isDuperLocation) {
                    window.location.reload();
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(exitDuperbrowseDone())];
            case 3:
                _d.sent();
                return [2 /*return*/];
            case 4:
                // if there is no non-root state, bail
                if (!location.state.duperbrowseState) {
                    window.location.reload();
                    return [2 /*return*/];
                }
                _b = location.state.duperbrowseState, streamId = _b.streamId, itemId = _b.itemId;
                return [4 /*yield*/, select(getIsValidStreamItem, streamId, itemId)];
            case 5:
                isValid = _d.sent();
                if (!isValid) {
                    window.location.reload();
                }
                return [4 /*yield*/, select(getCurrentItem)];
            case 6:
                currentItem = _d.sent();
                return [4 /*yield*/, all([
                        put(unloadDuperbrowseItem(currentItem)),
                        put(setCurrentStreamAndItem(streamId, itemId)),
                    ])];
            case 7:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
function handleNonDuperHistoryChange(_a) {
    var isDuperActive;
    var action = _a.payload.action;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                // we only need to handle popstates
                if (action !== 'POP') {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getIsAnyStreamActive)];
            case 1:
                isDuperActive = _b.sent();
                if (!isDuperActive) {
                    return [2 /*return*/];
                }
                // everything is terrible, just reload for sanity
                window.location.reload();
                return [2 /*return*/];
        }
    });
}
function handleLoadDuperbrowse(_a) {
    var currentItem, _b, result, entities;
    var _c = _a.payload, itemId = _c.itemId, stream = _c.stream;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, select(getCurrentItem)];
            case 1:
                currentItem = _d.sent();
                if (!currentItem) return [3 /*break*/, 3];
                return [4 /*yield*/, put(unloadDuperbrowseItem(currentItem))];
            case 2:
                _d.sent();
                _d.label = 3;
            case 3:
                if (!(isSimpleStream(stream) && isDeviationStream(stream))) return [3 /*break*/, 5];
                _b = normalize(stream.items, deviationListSchema), result = _b.result, entities = _b.entities;
                return [4 /*yield*/, put(openDuperbrowseWithEntities(itemId, __assign(__assign({}, stream), { items: result, itemSchema: 'deviation' }), entities))];
            case 4:
                _d.sent();
                return [2 /*return*/];
            case 5: return [4 /*yield*/, put(openDuperbrowse(itemId, stream))];
            case 6:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
function handleOpenDuperbrowse(_a) {
    var isHistoryManagementEnabled, currentItem, isRoot;
    var _b = _a.payload, currentOpenItem = _b.currentOpenItem, itemSchema = _b.itemSchema;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getIsHistoryManagementEnabled)];
            case 1:
                isHistoryManagementEnabled = _c.sent();
                return [4 /*yield*/, select(getCurrentItem)];
            case 2:
                currentItem = _c.sent();
                if (!currentItem) {
                    return [2 /*return*/];
                }
                logger.log('Opening duperbrowse', currentItem);
                isRoot = !(history.location.state && history.location.state.duperbrowseState);
                if (isRoot && isHistoryManagementEnabled) {
                    history.replace(__assign(__assign({}, history.location), { state: __assign(__assign({}, getNonDuperHistoryState()), { duperbrowseRoot: true }) }));
                }
                return [4 /*yield*/, all([
                        call(updateHistoryWith, currentItem),
                        put(loadDuperbrowseItem(currentOpenItem, itemSchema, undefined)),
                    ])];
            case 3:
                _c.sent();
                typeof window !== 'undefined' && scrollTo(window, 0, 0);
                return [2 /*return*/];
        }
    });
}
function handleExitDuperbrowse() {
    var currentItem, rootLocation;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getCurrentItem)];
            case 1:
                currentItem = _a.sent();
                if (!!currentItem) return [3 /*break*/, 4];
                return [4 /*yield*/, select(getRootLocation)];
            case 2:
                rootLocation = _a.sent();
                if (rootLocation) {
                    history.push(rootLocation);
                }
                return [4 /*yield*/, put(exitDuperbrowseDone())];
            case 3:
                _a.sent();
                return [2 /*return*/];
            case 4: return [4 /*yield*/, call(updateHistoryWith, currentItem)];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
// We removed the lastViewedItem after a timeout so
// we avoid any problems with scroll restoration if the component
// re-renders. This comes at cost of re-render :(
function handleExitDuperbrowseDone() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, delay(500)];
            case 1:
                _a.sent();
                return [4 /*yield*/, put(exitDuperbrowseResorationTimeout())];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default function rootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(moveNext, handleMoveNext),
                    takeEvery(movePrev, handleMovePrev),
                    takeEvery(duperbrowseHistoryChanged, handleHistoryChange),
                    takeEvery(historyChanged, handleNonDuperHistoryChange),
                    takeEvery(loadDuperbrowse, handleLoadDuperbrowse),
                    takeEvery(openDuperbrowse, handleOpenDuperbrowse),
                    takeEvery(exitDuperbrowse, handleExitDuperbrowse),
                    takeLatest(loadDuperbrowseItem, handleLoading),
                    takeLatest(exitDuperbrowseDone, handleExitDuperbrowseDone),
                    takeLatest(shutdownDuperbrowse, handleExitDuperbrowseDone),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map